import { APIService } from "./APIService"
import { ImageType } from "./types"

const getProfiles = (id: string) => APIService.get<null, string[]>(`/users/${id}/profiles`)

const getVerifyCode = () => APIService.get<null, null>(`/users/:userId/verify`)
const verify = (code: string, token?: string) =>
  APIService.post<null, null>(`/users/:userId/verify?code=${code}`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

const uploadImage = (file: any) => {
  const formData = new FormData()
  formData.append("file", file)

  return APIService.post<null, ImageType>(`/users/:userId/images`, formData)
}

export const UserService = {
  uploadImage,
  getVerifyCode,
  verify,
  getProfiles,
}
